import axios, { AxiosInstance } from 'axios';
import config from '../config';
import { getAuthToken, setupAuthInterceptor } from '../utils';
import { History } from 'history';

export const configureSubscriptionService = (service: AxiosInstance) => {

 service.interceptors.request.use(
     async (config) => {
       const token = getAuthToken()
       config.headers = config.headers || {}
       config.headers.Authorization = `Bearer ${token}`
       return token
     },
      (error: any) => {
    return Promise.reject(error)
 } 
 )

}

export const createSubscriptionService = (history?: History) => {

    const subscriptionService = axios.create({
        baseURL: config.subscriptionServiceURL
    })

    setupAuthInterceptor(subscriptionService, history)

    return subscriptionService
}

const subscriptionService = createSubscriptionService()

export {subscriptionService}

